const SelectWithSpecifyUtils = module.exports = {};

SelectWithSpecifyUtils.DEFAULT_SELECT_VALUE_PATH = 'id';
SelectWithSpecifyUtils.DEFAULT_SPECIFY_VALUE_PATH = 'name';
SelectWithSpecifyUtils.DEFAULT_OPTION_VALUE = '';
SelectWithSpecifyUtils.DEFAULT_OPTION_LABEL = 'No selection';
SelectWithSpecifyUtils.DEFAULT_SPECIFY_OPTION_VALUE = '__specify__';
SelectWithSpecifyUtils.DEFAULT_SPECIFY_OPTION_LABEL = 'Other (Specify Below)';

SelectWithSpecifyUtils.getConfig = (definition = {}) => {
    const labels = definition.labels || {};
    const messages = definition.messages || {};
    const valuePaths = definition.valuePaths || {};
    const defaultOption = definition.defaultOption || {};
    const specifyOption = definition.specifyOption || {};

    return {
        enableSwitch: !!definition.enableSwitch,
        selectValuePath: valuePaths.select || definition.selectValuePath || definition.valuePath || SelectWithSpecifyUtils.DEFAULT_SELECT_VALUE_PATH,
        specifyValuePath: valuePaths.specify || definition.specifyValuePath || SelectWithSpecifyUtils.DEFAULT_SPECIFY_VALUE_PATH,
        defaultOptionValue: typeof defaultOption.value === 'undefined'
            ? (typeof definition.defaultOptionValue === 'undefined'
                ? SelectWithSpecifyUtils.DEFAULT_OPTION_VALUE
                : definition.defaultOptionValue)
            : defaultOption.value,
        defaultOptionLabel: defaultOption.label
            || defaultOption.name
            || definition.defaultOptionLabel
            || definition.defaultOptionName
            || SelectWithSpecifyUtils.DEFAULT_OPTION_LABEL,
        hideDefaultOption: !!defaultOption.hidden || !!definition.hideDefaultOption,
        specifyOptionValue: specifyOption.value
            || definition.specifyOptionValue
            || SelectWithSpecifyUtils.DEFAULT_SPECIFY_OPTION_VALUE,
        specifyOptionLabel: specifyOption.label
            || specifyOption.name
            || definition.specifyOptionLabel
            || definition.specifyOptionName
            || SelectWithSpecifyUtils.DEFAULT_SPECIFY_OPTION_LABEL,
        specifyPlaceholderValue: specifyOption.placeholderValue
            || definition.specifyPlaceholderValue
            || specifyOption.label
            || specifyOption.name
            || definition.specifyOptionLabel
            || definition.specifyOptionName
            || SelectWithSpecifyUtils.DEFAULT_SPECIFY_OPTION_LABEL,
        requiredMessage: messages.required || definition.requiredMessage || 'Must choose or specify',
        specifyRequiredMessage: messages.specifyRequired || definition.specifyRequiredMessage || 'Specify is required',
        selectLabel: labels.select || definition.selectLabel || definition.label,
        specifyLabel: labels.specify || definition.specifyLabel || 'Specify'
    };
};

SelectWithSpecifyUtils.getPath = (obj, path) => {

    if (!path) {
        return obj;
    }

    return String(path).split('.').reduce((current, key) => current?.[key], obj);
};

SelectWithSpecifyUtils.setPath = (obj = {}, path, value) => {
    const keys = String(path || '').split('.').filter(Boolean);

    if (!keys.length) {
        return value;
    }

    const root = {
        ...(obj || {})
    };
    let current = root;

    keys.slice(0, -1).forEach((key) => {
        current[key] = {
            ...(current[key] || {})
        };
        current = current[key];
    });

    current[keys[keys.length - 1]] = value;
    return root;
};

SelectWithSpecifyUtils.getSelectValue = ({
    value,
    definition
}) => SelectWithSpecifyUtils.getPath(value, SelectWithSpecifyUtils.getConfig(definition).selectValuePath);

SelectWithSpecifyUtils.getSpecifyValue = ({
    value,
    definition
}) => SelectWithSpecifyUtils.getPath(value, SelectWithSpecifyUtils.getConfig(definition).specifyValuePath);

SelectWithSpecifyUtils.setSelectValue = ({
    value,
    definition,
    nextValue
}) => SelectWithSpecifyUtils.setPath(
    value,
    SelectWithSpecifyUtils.getConfig(definition).selectValuePath,
    nextValue
);

SelectWithSpecifyUtils.setSpecifyValue = ({
    value,
    definition,
    nextValue
}) => SelectWithSpecifyUtils.setPath(
    value,
    SelectWithSpecifyUtils.getConfig(definition).specifyValuePath,
    nextValue
);

SelectWithSpecifyUtils.buildValue = ({
    definition,
    selectValue = null,
    specifyValue = null
}) => {

    const valueWithSelect = SelectWithSpecifyUtils.setSelectValue({
        value: {},
        definition,
        nextValue: selectValue
    });

    return SelectWithSpecifyUtils.setSpecifyValue({
        value: valueWithSelect,
        definition,
        nextValue: specifyValue
    });
};

SelectWithSpecifyUtils.buildOffValue = ({
    definition
}) => SelectWithSpecifyUtils.buildValue({
    definition,
    selectValue: null,
    specifyValue: null
});

SelectWithSpecifyUtils.buildPendingValue = ({
    definition
}) => SelectWithSpecifyUtils.buildValue({
    definition,
    selectValue: null,
    specifyValue: ''
});

SelectWithSpecifyUtils.buildSelectedValue = ({
    definition,
    selectedValue
}) => SelectWithSpecifyUtils.buildValue({
    definition,
    selectValue: selectedValue,
    specifyValue: null
});

SelectWithSpecifyUtils.buildSpecifyPlaceholderValue = ({
    definition
}) => SelectWithSpecifyUtils.buildValue({
    definition,
    selectValue: null,
    specifyValue: SelectWithSpecifyUtils.getConfig(definition).specifyPlaceholderValue
});

SelectWithSpecifyUtils.buildSpecifyTextValue = ({
    definition,
    textValue
}) => {
    const trimmedValue = String(textValue || '').trim();

    return SelectWithSpecifyUtils.buildValue({
        definition,
        selectValue: null,
        specifyValue: trimmedValue ? textValue : SelectWithSpecifyUtils.getConfig(definition).specifyPlaceholderValue
    });
};

SelectWithSpecifyUtils.isEnabled = ({
    value,
    definition
}) => {

    const config = SelectWithSpecifyUtils.getConfig(definition);

    if (!config.enableSwitch) {
        return true;
    }

    return !!SelectWithSpecifyUtils.getSelectValue({
        value,
        definition
    }) || SelectWithSpecifyUtils.getSpecifyValue({
        value,
        definition
    }) !== null;
};

SelectWithSpecifyUtils.isSpecifySelected = ({
    value,
    definition
}) => {

    const selectValue = SelectWithSpecifyUtils.getSelectValue({
        value,
        definition
    });
    const specifyValue = SelectWithSpecifyUtils.getSpecifyValue({
        value,
        definition
    });

    return !selectValue
        && specifyValue !== null
        && typeof specifyValue !== 'undefined'
        && specifyValue !== '';
};

SelectWithSpecifyUtils.getSelectedOptionValue = ({
    value,
    definition
}) => {

    const config = SelectWithSpecifyUtils.getConfig(definition);
    const selectValue = SelectWithSpecifyUtils.getSelectValue({
        value,
        definition
    });

    if (selectValue) {
        return selectValue;
    }

    if (SelectWithSpecifyUtils.isSpecifySelected({
        value,
        definition
    })) {
        return config.specifyOptionValue;
    }

    return config.defaultOptionValue;
};

SelectWithSpecifyUtils.getSpecifyTextValue = ({
    value,
    definition
}) => {

    const config = SelectWithSpecifyUtils.getConfig(definition);
    const specifyValue = SelectWithSpecifyUtils.getSpecifyValue({
        value,
        definition
    });

    if (specifyValue === config.specifyPlaceholderValue) {
        return '';
    }

    return specifyValue || '';
};

SelectWithSpecifyUtils.validate = ({
    value,
    definition = {}
}) => {

    const config = SelectWithSpecifyUtils.getConfig(definition);

    if (!SelectWithSpecifyUtils.isEnabled({
        value,
        definition
    })) {
        return null;
    }

    const selectValue = SelectWithSpecifyUtils.getSelectValue({
        value,
        definition
    });
    const specifyValue = SelectWithSpecifyUtils.getSpecifyValue({
        value,
        definition
    });

    if (!selectValue && specifyValue === '') {
        return config.requiredMessage;
    }

    if (SelectWithSpecifyUtils.isSpecifySelected({
        value,
        definition
    }) && !SelectWithSpecifyUtils.getSpecifyTextValue({
            value,
            definition
        }).trim()) {
        return config.specifyRequiredMessage;
    }

    return null;
};

SelectWithSpecifyUtils.normalizeSelectedValueForSubmit = ({
    selectedValue,
    definition = {}
}) => {

    if (typeof definition.normalizeSelectedValueForSubmit === 'function') {
        return definition.normalizeSelectedValueForSubmit(selectedValue);
    }

    return {
        selectValue: selectedValue,
        specifyValue: null
    };
};

SelectWithSpecifyUtils.normalizeForSubmit = ({
    value,
    definition = {}
}) => {

    if (!SelectWithSpecifyUtils.isEnabled({
        value,
        definition
    })) {
        return SelectWithSpecifyUtils.buildOffValue({
            definition
        });
    }

    const selectValue = SelectWithSpecifyUtils.getSelectValue({
        value,
        definition
    });

    if (selectValue) {
        const normalizedValue = SelectWithSpecifyUtils.normalizeSelectedValueForSubmit({
            selectedValue: selectValue,
            definition
        });

        return SelectWithSpecifyUtils.buildValue({
            definition,
            selectValue: normalizedValue.selectValue,
            specifyValue: normalizedValue.specifyValue
        });
    }

    const specifyTextValue = SelectWithSpecifyUtils.getSpecifyTextValue({
        value,
        definition
    });

    return SelectWithSpecifyUtils.buildValue({
        definition,
        selectValue: null,
        specifyValue: specifyTextValue.trim() ? specifyTextValue : null
    });
};
